import { TriangleAlert } from 'lucide-react'

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { Button } from '@/components/ui/button'

/**
 * Table-view banner for open-slot problems. The calendar folds slot errors
 * and truncation into its own states, but the table can't: folding them into
 * the table's error state would replace the appointments with an error
 * screen. So the table keeps its rows and says what happened to the slots.
 */
export function OpenSlotsNotice({
  error,
  truncated,
  onRetry,
}: {
  error: Error | null
  truncated: boolean
  onRetry: () => void
}) {
  if (error) {
    return (
      <Alert variant="destructive">
        <TriangleAlert className="h-4 w-4" />
        <AlertTitle>Couldn&apos;t load open slots</AlertTitle>
        <AlertDescription>
          <p>
            {error.message || 'Something went wrong on our end.'} Appointments
            are unaffected.
          </p>
          <Button size="sm" variant="outline" onClick={onRetry}>
            Retry
          </Button>
        </AlertDescription>
      </Alert>
    )
  }
  if (truncated) {
    return (
      <Alert>
        <TriangleAlert className="h-4 w-4" />
        <AlertTitle>Open slots are only partially loaded</AlertTitle>
        <AlertDescription>
          There are more open slots than could be fetched. Narrow the Date range
          or filters to see them all.
        </AlertDescription>
      </Alert>
    )
  }
  return null
}
